/*
* (c) W3Cms
* */
const styles = ['font-size: 14px', 'color: #ffffff', 'background-color: #7FA113', 'padding: 4px 0px 4px 8px'].join(';')
    , brandStyles = ['font-size: 14px', 'color: #ffffff', 'background-color: #293133', 'padding: 4px 8px 4px 8px', 'font-weight: bold'].join(';')
    , text = '%cMade by %cW3design https://www.w3design.it/';
console.log(text, styles, brandStyles);

import $ from "jquery";
window.$ = $;
window.jQuery = $;

$(document).ready(function(){
    $('.gotoSection').click(function(e){
        e.preventDefault();
        if(!$('#menu-button').is('.collapsed')) {
            $('.hamburger').trigger('click');
        }
        let position = $(this).attr('href');
        $("html, body").animate({scrollTop:$(position).offset().top}, 'slow');
    })
});

